import { render, staticRenderFns } from "./u-file-input-solo-tile.vue?vue&type=template&id=5faa79b9&scoped=true&"
import script from "./u-file-input-solo-tile.vue?vue&type=script&lang=js&"
export * from "./u-file-input-solo-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa79b9",
  null
  
)

export default component.exports